<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: BtnIcon                                               |
| Section: atoms                                                   |
| Purpose: Icon-only link button with dynamic SVG asset loading.   |
+------------------------------------------------------------------+
-->
<template>
    <a :href="href" target="_blank">
        <img :src="iconSrc" alt="icon" />
    </a>
</template>

<script>
export default {
    name: 'BtnIcon',
    props: {
        iconName: {
            type: String,
            required: true
        },
        href: {
            type: String,
            default: '#'
        }
    },
    computed: {
        iconSrc() {
            try {
                return require(`@/assets/icons/${this.iconName}.svg`);
            } catch (error) {
                console.error(`Icon ${this.iconName} not found`, error);
                return '';
            }
        }
    }
}
</script>

<style scoped>
a {
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 100%;
    background: var(--brand-color-1);
    transition: var(--transition-bounce);
    box-shadow: 0px 0px 0px 0px var(--brand-color-1);
}

a:hover {
    box-shadow: 0px 0px 0px 4px var(--brand-color-1);
}

img {
    height: 100%;
    max-height: 16px;
}
</style>